/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserDetail } from './UserDetail';
import {
    UserDetailFromJSON,
    UserDetailFromJSONTyped,
    UserDetailToJSON,
} from './UserDetail';

/**
 * 
 * @export
 * @interface FindOneUser200Response
 */
export interface FindOneUser200Response {
    /**
     * 
     * @type {UserDetail}
     * @memberof FindOneUser200Response
     */
    data?: UserDetail;
}

/**
 * Check if a given object implements the FindOneUser200Response interface.
 */
export function instanceOfFindOneUser200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindOneUser200ResponseFromJSON(json: any): FindOneUser200Response {
    return FindOneUser200ResponseFromJSONTyped(json, false);
}

export function FindOneUser200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindOneUser200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : UserDetailFromJSON(json['data']),
    };
}

export function FindOneUser200ResponseToJSON(value?: FindOneUser200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': UserDetailToJSON(value.data),
    };
}

